import { Avatar, ButtonBase, CircularProgress, Menu, MenuItem } from '@mui/material';
import { X } from '@phosphor-icons/react';
import { Form, Formik } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { AiOutlineDelete } from 'react-icons/ai';
import { BiMinus } from 'react-icons/bi';
import { BsArrowLeft, BsPlusLg } from 'react-icons/bs';
import { CiMenuKebab } from 'react-icons/ci';
import { GoPlusCircle } from 'react-icons/go';
import { HiSearch } from 'react-icons/hi';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import { RiArrowRightSLine } from 'react-icons/ri';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Tag from 'src/assets/images/Tag.svg';
import { CurrencyAmount } from 'src/containers/currency';
import {
  addCurrentOrder,
  addCurrentOrderInfo,
  addCurrentUser,
  clearCurrentOrder,
  decreaseQuantityOrder,
  fetchUsers,
  increaseQuantityOrder,
} from 'src/redux/action/currentOrder.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';
import { FinalBillPrintProv } from '../bill-print/provisional-bill';
import Button from '../button';
import Modal from '../modal';
import Radio from '../radio';
import TextField from '../text-field';
import { getDiscountStorageValue } from '../discount-storage';
import { TicketIcon } from '@phosphor-icons/react';

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  phone: Yup.string()
    .test('is-phone', 'Invalid phone number', function (value) {
      const phoneRegExp = /^[0-9]{10}$/;
      if (!value) {
        return true;
      }
      return phoneRegExp.test(value);
    })
    .required('Phone is required'),
  email: Yup.string().email('Provide valid email').notRequired(),
});
const FORM_VALIDATION_DISC = Yup.object().shape({
  value: Yup.string().required('value is required'),
});

const Order: React.FC<any> = ({
  payment,
  isEditing,
  orderId,
  openTicket,
  orderData,
  tableId,
  previousData,
  fetchTableDataBackOffice,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const position = useSelector(
    ({ currencyData }: RootState) => currencyData.myCurrencyData?.symbolPosition
  );
  const symbol = useSelector(
    ({ currencyData }: RootState) =>
      currencyData.myCurrencyData?.symbol ?? 'Rs.'
  );
  const userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '');
  const allowOrderCharge = userInfo?.userInfo?.permissions?.allowOrderCharge ?? false;  
  const { orders, users, currentUser, deliveryCharge, orderInfo } = useSelector(
    ({ currentOrderData }: RootState) => currentOrderData
  );
  
  const taxes = orderInfo?.extraCharges || [];
  const [assignCustomerModal, setAssignCustomerModal] = useState(false);
  const [filteredSearchCustomers, setFilteredSearchCustomers] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);
  const [createCustomerLoading, setCreateCustomerLoading] = useState(false);
  const [cancelTicket, setCancelTicket] = useState(false);
  const [chargeWholeLoading, setChargeWholeLoading] = useState(false);
  const [hasItemSavingLoading, setHasItemSavingLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const { settingData } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const businessName = settingData?.businessInfo?.name;
  const businessAddress = settingData?.businessInfo?.address;
  const panNumber = settingData?.businessInfo?.pan;

  const [showTotalDiscInput, setShowTotalDiscInput] =
    React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorElDiscMenu, setAnchorElDiscMenu] =
    React.useState<null | HTMLElement>(null);
  const [anchorElDiscMenuUpdate, setAnchorElDiscMenuUpdate] =
    React.useState<null | HTMLElement>(null);
  const [showApplyDiscModal, setShowApplyDiscModal] = useState(false);
  const [showUpdateDiscModal, setShowUpdateDiscModal] = useState(false);
  const [discountItem, setDiscountItem] = useState<any>();
  const open = Boolean(anchorEl);
  const openDisc = Boolean(anchorElDiscMenu);
  const openDiscUpdate = Boolean(anchorElDiscMenuUpdate);
  const discountSend = getDiscountStorageValue(orderInfo);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickDiscMenu = (
    event: React.MouseEvent<HTMLElement>,
    item: any
  ) => {
    setAnchorElDiscMenu(event.currentTarget);
    setDiscountItem(item);
  };
  const handleClickDiscMenuUpdate = (
    event: React.MouseEvent<HTMLElement>,
    item: any
  ) => {
    setAnchorElDiscMenuUpdate(event.currentTarget);
    setDiscountItem(item);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseDiscMenu = () => {
    setAnchorElDiscMenu(null);
    setAnchorElDiscMenuUpdate(null);
    setDiscountItem(null);
  };

  const filteredCustomers = useMemo(() => {
    const a = users || [];
    if (filteredSearchCustomers) {
      const trimmedSearch = filteredSearchCustomers.trim().toLowerCase();
      return a.filter(
        (item) =>
          (item.name && item.name.toLowerCase().includes(trimmedSearch)) ||
          (item.email && item.email.toLowerCase().includes(trimmedSearch)) ||
          (item.phone && item.phone.toLowerCase().includes(trimmedSearch))
      );
    } else {
      return a;
    }
  }, [filteredSearchCustomers, users]);

  const subTotal = orderInfo?.subTotal;

  const saveTicketWithExistingItems = async (
    pay: boolean,
    newOrders?: any,
    prevItems?: any
  ) => {
    if (cancelTicket || chargeWholeLoading || hasItemSavingLoading) {
      return;
    }
    if (pay) {
      setChargeWholeLoading(true);
    } else {
      setHasItemSavingLoading(true);
    }
    const oldData = prevItems || previousData;
    const orderItems = newOrders?.items || orders.items;
    const newData = [];

    const oldDataMap = oldData.reduce((map: any, item: any) => {
      map[item.id] = item;
      return map;
    }, {});

    for (const orderItem of orderItems) {
      if (!orderItem?.id || !oldDataMap[orderItem?.id]) {
        newData.push(orderItem);
      } else {
        // There is a matching item in oldData
        const oldItem = oldDataMap[orderItem?.id];
        const quantityDiff = orderItem.quantity - oldItem.quantity;
        if (orderItem.quantity < orderItem.decreaseLimit) {
          toastAlert('error', 'Cannot remove this item, already cooking');
          setChargeWholeLoading(false);
          setHasItemSavingLoading(false);
          return;
        }
        if (quantityDiff !== 0) {
          // Update quantity in newData based on the difference
          const newItem = { ...oldItem }; // Copy oldItem
          newItem.quantity = quantityDiff;
          newData.push(newItem);
        }
      }
    }

    for (const oldItem of oldData) {
      if (!orderItems.some((orderItem: any) => orderItem?.id === oldItem.id)) {
        const newItem = { ...oldItem };
        newItem.quantity = -oldItem.quantity;
        newData.push(newItem);
      }
    }
    if (newData.length === 0) {
      if (pay) {
        navigate('/payment', {
          state: {
            orderId: null,
            tableId: tableId,
            wholeTable: true,
            discountSend,
          },
        });
        setChargeWholeLoading(false);
        return;
      }
      // navigate('/dine-in');
      setHasItemSavingLoading(false);
    } else {
      try {
        const user = currentUser?.id ?? null;
        const a = {
          businessId: orders.businessId,
          type: orders.type,
          tableId: tableId,
          tableName: orders.tableName,
          userId: user,
          origin: 'pos_device',
          items: newData,
        };
        const res: any = await Service.post('/orders/openCheck/add ', a);
        const response = res?.data?.combinedOrders?.orderInfo?.items;
        dispatch(addCurrentOrderInfo(res?.data?.combinedOrders?.orderInfo));
        const userInfo = JSON.parse(
          window.localStorage.getItem('userInfo') || ''
        );
        if (!pay) {
          setHasItemSavingLoading(false);
          const a = {
            businessId: userInfo?.businessInfo?.id,
            type: orders.type,
            tableId: tableId,
            tableName: orders.tableName,
            userId: user,
            origin: 'pos_device',
            promo: null,
            deliveryCharge: 0,
            items:
              response.length > 0
                ? response.map((item: any) => {
                    return {
                      ...item,
                      name: item.itemName,
                      identifierId: item.id,
                      deliveryCharge: 0,
                      selectedModifiers: item.allModifiers.map(
                        (modifier: any) => {
                          const optionsWithSelected = modifier.options.map(
                            (option: any) => {
                              const optionInModifiers = item.modifiers
                                .find((mod: any) => mod.id === modifier.id)
                                ?.options.find(
                                  (op: any) => op.id === option.id
                                );
                              return {
                                id: option.id,
                                price: option.price,
                                name: option.name,
                                hasSelected: !!optionInModifiers,
                              };
                            }
                          );
                          return {
                            id: modifier.id,
                            name: modifier.name,
                            options: optionsWithSelected,
                          };
                        }
                      ),
                      note: item?.note || '',
                    };
                  })
                : [],
          };
          if (response.length > 0) {
            dispatch(clearCurrentOrder());
            dispatch(addCurrentOrder({ ...a }));
            if (currentUser) {
              const currentUserWithDefaults = {
                ...currentUser,
                email: currentUser.email ?? null,
                image: currentUser.image ?? null,
              };

              dispatch(addCurrentUser(currentUserWithDefaults));
            }
          }
          // navigate('/dine-in');
        } else {
          const userInfo = JSON.parse(
            window.localStorage.getItem('userInfo') || ''
          );
          const a = {
            businessId: userInfo?.businessInfo?.id,
            type: orders.type,
            tableId: tableId,
            tableName: orders.tableName,
            userId: user,
            origin: 'pos_device',
            promo: null,
            deliveryCharge: 0,
            items:
              response.length > 0
                ? response.map((item: any) => {
                    return {
                      ...item,
                      name: item.itemName,
                      identifierId: item.id,
                      deliveryCharge: 0,
                      selectedModifiers: item.allModifiers.map(
                        (modifier: any) => {
                          const optionsWithSelected = modifier.options.map(
                            (option: any) => {
                              const optionInModifiers = item.modifiers
                                .find((mod: any) => mod.id === modifier.id)
                                ?.options.find(
                                  (op: any) => op.id === option.id
                                );
                              return {
                                id: option.id,
                                price: option.price,
                                name: option.name,
                                hasSelected: !!optionInModifiers,
                              };
                            }
                          );
                          return {
                            id: modifier.id,
                            name: modifier.name,
                            options: optionsWithSelected,
                          };
                        }
                      ),
                      note: item?.note || '',
                    };
                  })
                : [],
          };
          if (response.length > 0) {
            dispatch(clearCurrentOrder());
            dispatch(addCurrentOrder({ ...a }));
            navigate('/payment', {
              state: {
                orderId: null,
                tableId: tableId,
                wholeTable: true,
                discountSend,
              },
            });
          }
          setChargeWholeLoading(false);
          return;
        }
      } catch (err: any) {
        if (!pay) {
          setHasItemSavingLoading(false);
        } else {
          setChargeWholeLoading(false);
        }
      }
    }
  };

  const addCurrentCustomer = (user?: boolean) => {
    if (!selectedCustomer) {
      toastAlert('error', 'Select a customer');
      return;
    }
    const a = users.find((i) => i.id === selectedCustomer) || null;
    const data = {
      id: a?.id || '',
      name: a?.name || '',
      email: a?.email || null,
      phone:
        typeof a?.phone === 'string' ? parseInt(a.phone, 10) : a?.phone || null,
      image: a?.image || null,
    };

    if (a) {
      dispatch(addCurrentUser(data));
    }
    toastAlert('success', `Customer selected`);

    if (user) {
      const changeUser = async () => {
        const data = {
          customerId: user ? a?.id : null,
          tableId: orders.tableId || tableId,
        };
        try {
          await Service.post('/floors/tables/assign/customer', data);
          toastAlert('success', `Customer changed successfully`);
        } catch (err: any) {}
      };
      changeUser();
    }
  };

  const intValues = {
    name: '',
    email: '',
    phone: null,
  };

  const handleModal = () => {
    setShowCreateCustomerModal(false);
  };

  const [cusErrMsg, setCusErrMsg] = useState('');

  const handleCreateCustomer = async (val: any) => {
    const payload = {
      name: val.name,
      email: val.email,
      phone: val.phone,
    };
    setCreateCustomerLoading(true);
    try {
      await Service.post('/users/create', payload);
      setShowCreateCustomerModal(false);
      dispatch(fetchUsers() as any);
      setCreateCustomerLoading(false);
      toastAlert('success', `User created successfully`);
    } catch (err: any) {
      setCreateCustomerLoading(false);
      setShowCreateCustomerModal(false);
      setCusErrMsg(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    setSelectedCustomer('');
    setFilteredSearchCustomers('');
  }, [assignCustomerModal]);

  useEffect(() => {
    setSelectedCustomer('');
    setFilteredSearchCustomers('');
    setAssignCustomerModal(false);
  }, [currentUser]);

  const handleCloseModal = () => {
    setShowModal(false);
    setCancelReason('');
  };

  const [cancelOrderErr, setCancelOrderErr] = useState('');

  const cancelOrder = async () => {
    if (!orderId || cancelTicket) {
      return;
    }
    if (cancelReason.trim() === '') {
      toastAlert('error', 'Provide reason for cancellation');
      handleCloseModal();
      return;
    }
    const data = {
      id: orderId,
      newStatus: 'canceled',
      cancelledReason: cancelReason,
    };
    setShowModal(false);
    setCancelTicket(true);
    handleCloseModal();
    try {
      await Service.post('/orders/status', data);
      toastAlert('success', `Order cancelled successfully`);
      navigate('/dine-in');
      setCancelTicket(false);
    } catch (err: any) {
      setCancelTicket(false);
      setCancelOrderErr(err?.response?.data?.message);
    }
  };

  const changeUserEmpty = async () => {
    const data = {
      customerId: null,
      tableId: orders.tableId || tableId,
    };
    try {
      await Service.post('/floors/tables/assign/customer', data);
      toastAlert('success', `Customer removed successfully`);
    } catch (err: any) {}
  };

  const handlePrintFinalBill = () => {
    const prtContent = document.getElementById(`finalBillPrintProv`);
    if (!prtContent) return;
    const printWindow = window.open(
      '',
      '',
      'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0'
    );
    if (printWindow) {
      printWindow.document.write(prtContent.innerHTML);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error('Failed to open a new window for printing.');
    }
  };

  const [errMsgDiscount, setErrMsgDiscount] = useState('');

  const handleApplyDiscount = async (values: any, type: string) => {
    try {
      setShowApplyDiscModal(false);
      setShowUpdateDiscModal(false);
      if (type === 'whole') {
        const payload = {
          type: values.type,
          value: values.value,
        };
        await Service.post(
          `/floors/tables/${orders.tableId}/discount/order`,
          payload
        );
        if (fetchTableDataBackOffice) fetchTableDataBackOffice();
        return setShowTotalDiscInput(false);
      } else {
        const payload = {
          itemId: discountItem.itemId,
          variantId: discountItem.variantId,
          spiceLevel: discountItem.spiceLevel,
          modifiers: discountItem.selectedModifiers || [],
          discountInfo: {
            type: values.type,
            value: values.value,
          },
        };
        await Service.post(
          `/floors/tables/${orders.tableId}/discount/item-level`,
          payload
        );
        if (fetchTableDataBackOffice) fetchTableDataBackOffice();
      }
    } catch (error: any) {
      setErrMsgDiscount(error?.response?.data?.message);
    }
  };

  const handleRemoveDiscount = async (values: any, type: string) => {
    setShowApplyDiscModal(false);
    setShowUpdateDiscModal(false);
    if (type === 'whole') {
      await Service.delete(`/floors/tables/${orders.tableId}/discount/order`);
      if (fetchTableDataBackOffice) fetchTableDataBackOffice();
      return setShowTotalDiscInput(false);
    } else {
      const payload = {
        itemId: discountItem.itemId,
        variantId: discountItem.variantId,
        spiceLevel: discountItem.spiceLevel,
        modifiers: discountItem.selectedModifiers || [],
        discountInfo: {
          type: values.type,
          value: values.value,
        },
      };
      await Service.delete(
        `/floors/tables/${orders.tableId}/discount/item-level`,
        { data: payload }
      );
      if (fetchTableDataBackOffice) fetchTableDataBackOffice();
    }
  };

  const ApplyDiscountContent = (type: string) => {
    let initValues = {
      type: discountItem?.itemLevelDiscount?.type || 'amount',
      value: discountItem?.itemLevelDiscount?.value || '',
      amount: discountItem?.itemLevelDiscount?.amount || 0,
    };
    if (type === 'whole') {
      initValues.type = orderInfo?.customDiscountInfo?.type || 'amount';
      initValues.value = orderInfo?.customDiscountInfo?.value || '';
      initValues.amount = orderInfo?.customDiscountInfo?.amount || 0;
    }
    return (
      <Formik
        onSubmit={(e) => handleApplyDiscount(e, type)}
        initialValues={initValues}
        validationSchema={FORM_VALIDATION_DISC}
        validateOnMount
      >
        {({ isSubmitting, isValid, values }) => (
          <Form className="mt-5 w-full">
            <label htmlFor="" className="pb-3">
              Type
            </label>
            <div className="mt-2 mb-5">
              <Radio
                name="type"
                labelOne="Amount"
                labelTwo="Percent"
                valueOne="amount"
                valueTwo="percent"
                selectedValue={initValues.type}
              />
            </div>
            <TextField
              name="value"
              label={`Discount ${values.type}`}
              placeholder={`Enter discount ${values.type}`}
              type="text"
            />
            <div className="flex items-center justify-end space-x-2">
              {type === 'whole' && initValues.amount > 0 && (
                <Button
                  type="button"
                  text={'remove discount'}
                  variant="outline"
                  onClick={() => handleRemoveDiscount({}, 'whole')}
                />
              )}
              <Button
                type="submit"
                text={'apply discount'}
                isSubmitting={isSubmitting}
                isValid={isValid}
                variant="primary"
              />
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  const ApplyDiscount = (item: any) => {
    if (item.discountAmount > 0) return;
    return (
      <>
        <div
          id="basic-button"
          aria-controls={openDisc ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openDisc ? 'true' : undefined}
          onClick={(e) => handleClickDiscMenu(e, item)}
        >
          <CiMenuKebab fontSize={16} />
        </div>
        <Menu
          id="basic-menu"
          anchorEl={anchorElDiscMenu}
          open={openDisc}
          onClose={handleCloseDiscMenu}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          PaperProps={{
            style: {
              boxShadow: 'none',
              width: '170px',
              marginTop: '10px',
              border: '1px solid #F1F0F6',
              height: 'fit-content',
              backgroundColor: '#FFFFFF',
              padding: '0',
              overflow: 'hidden',
            },
          }}
        >
          <MenuItem
            onClick={() => {
              setAnchorElDiscMenu(null);
              setShowApplyDiscModal(true);
            }}
          >
            Apply Discount
          </MenuItem>
        </Menu>
        {showApplyDiscModal && (
          <Modal
            onClick={() => setShowApplyDiscModal(false)}
            title={<span>Apply Discount</span>}
          >
            <div className="flex items-center">
              <div className="flex w-full">{ApplyDiscountContent('')}</div>
            </div>
          </Modal>
        )}
      </>
    );
  };

  const UpdateDiscount = (item: any) => {
    if (item.discountAmount === 0) return;
    return (
      <>
        <div
          id="basic-button"
          aria-controls={openDiscUpdate ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openDiscUpdate ? 'true' : undefined}
          onClick={(e) => handleClickDiscMenuUpdate(e, item)}
        >
          <CiMenuKebab fontSize={16} />
        </div>
        <Menu
          id="basic-menu"
          anchorEl={anchorElDiscMenuUpdate}
          open={openDiscUpdate}
          onClose={handleCloseDiscMenu}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          PaperProps={{
            style: {
              boxShadow: 'none',
              width: '170px',
              marginTop: '10px',
              border: '1px solid #F1F0F6',
              height: 'fit-content',
              backgroundColor: '#FFFFFF',
              padding: '0',
              overflow: 'hidden',
            },
          }}
        >
          <MenuItem
            onClick={() => {
              setAnchorElDiscMenu(null);
              setAnchorElDiscMenuUpdate(null);
              setShowUpdateDiscModal(true);
            }}
          >
            Update Discount
          </MenuItem>
          <MenuItem
            onClick={() => {
              setAnchorElDiscMenu(null);
              setAnchorElDiscMenuUpdate(null);
              handleRemoveDiscount(
                {
                  type: discountItem?.itemLevelDiscount?.type,
                  value: discountItem?.itemLevelDiscount?.value,
                },
                ''
              );
            }}
          >
            Remove Discount
          </MenuItem>
        </Menu>
        {showUpdateDiscModal && (
          <Modal
            onClick={() => setShowUpdateDiscModal(false)}
            title={<span>Update Discount</span>}
          >
            <div className="flex items-center">
              <div className="flex w-full">{ApplyDiscountContent('')}</div>
            </div>
          </Modal>
        )}
      </>
    );
  };

  const DiscountApplyDiv = () => {
    return (
      <div className="flex">
        {!showTotalDiscInput && (
          <ButtonBase
            className="h-12 w-full bg-success"
            onClick={() => {
              setShowTotalDiscInput(true);
              setDiscountItem(null);
            }}
          >
            <span className="mr-auto">Apply Discount</span>
            <RiArrowRightSLine fontSize={20} />
          </ButtonBase>
        )}
        {showTotalDiscInput && (
          <div className="flex flex-col w-full shadow-inner p-1">
            <X
              className="ml-auto"
              onClick={() => setShowTotalDiscInput(false)}
            />
            {ApplyDiscountContent('whole')}
          </div>
        )}
      </div>
    );
  };

  const renderCalculatedPrice = (item: any) => {
    if (item.discountAmount > 0) {
      return (
        <div className="flex gap-[2px] items-center text-sm">
          {position === 'before' && <span>{symbol}</span>}
          {item.discountAmount > 0 && (
            <span className="line-through text-light-gray font-semibold ml-1">
              {item.price}
            </span>
          )}
          <span className="ml-1">{item.priceAfterItemDiscount}</span>
          {position === 'after' && <span>{symbol}</span>}
        </div>
      );
    }
    return (
      <div className="flex gap-[2px] items-center text-sm">
        {position === 'before' && <span>{symbol}</span>}
        <span className="ml-1">{item.price}</span>
        {position === 'after' && <span>{symbol}</span>}
      </div>
    );
  };

  const getItemizedDiscount =
    orderInfo?.customDiscountInfo?.individualItemAmount ?? 0;
  const getWholeDiscount = orderInfo?.customDiscountInfo?.amount ?? 0;

  const renderDiscountInfoTotal = () => {
    if (orderInfo?.customDiscountInfo?.individualItemAmount === 0) return;
    const totalDiscount = getItemizedDiscount;
    if (totalDiscount === 0) return;

    return (
      <div className="w-full h-[24px] flex justify-between items-center">
        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#949CC0]">
          Itemized Discount
        </div>
        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#2B2B2B]">
          <CurrencyAmount amount={totalDiscount} />
        </div>
      </div>
    );
  };

  const renderDiscountInfoTotalWhole = () => {
    const totalDiscount = getWholeDiscount;
    if (totalDiscount === 0) return;

    return (
      <div className="w-full h-[24px] flex justify-between items-center">
        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#949CC0]">
          Applied Discount
        </div>
        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#2B2B2B]">
          <CurrencyAmount amount={totalDiscount} />
        </div>
      </div>
    );
  };

  const renderAmountAfterDiscount = () => {
    const totalDiscount = getItemizedDiscount + getWholeDiscount;
    if (totalDiscount === 0) return;
    const totalAfterDiscount = subTotal - totalDiscount;

    return (
      <div className="w-full h-[24px] flex justify-between items-center">
        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#949CC0]">
          Total after discount
        </div>
        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#2B2B2B]">
          <CurrencyAmount amount={totalAfterDiscount.toFixed(2)} />
        </div>
      </div>
    );
  };

  const renderTotal = () => {
    const total = orderInfo?.total;
    return (
      <div className="w-full h-[24px] flex justify-between items-center">
        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#949CC0]">
          Total
        </div>
        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#2B2B2B]">
          <CurrencyAmount amount={total} />
        </div>
      </div>
    );
  };

  return (
    <div
      className={`w-[332px] fixed top-0 right-0 h-full  border flex flex-col border-[#F1F0F6] mb-3 ${
        orders.items.length <= 0 ? 'h-fit' : ''
      } `}
    >
      <div className="h-[62px] w-[332px] flex justify-between items-center border-b border-[#F1F0F6]  px-[15px]">
        {assignCustomerModal ? (
          <>
            <div
              className="font-Outfit font-semibold text-[18px] h-[62px] leading-[27px] flex gap-2 items-center cursor-pointer"
              onClick={() => {
                setAssignCustomerModal(false);
              }}
            >
              <BsArrowLeft fontSize={22} />
              Assign to customer
            </div>
          </>
        ) : (
          <>
            <div className="font-Outfit font-semibold text-[18px] w-full mr-2 leading-[27px] h-[62px] flex items-center">
              {!payment && !openTicket && orders?.items?.length > 0 && (
                <div
                  className="w-full h-[41px] ml-2 flex justify-center bg-[#4062FF] text-[#FFFFFF] items-center rounded-lg cursor-pointer font-Outfit font-semibold text-[15px] leading-5"
                  onClick={() => {
                    handlePrintFinalBill();
                  }}
                >
                  Print Bill
                </div>
              )}
              {!payment && openTicket && (
                <>
                  {orderData.type === 'takeaway' && (
                    <>Takeaway - {orderData?.referenceNumber}</>
                  )}
                  {orderData.type === 'dine_in' && (
                    <>Table - {orderData?.table?.name}</>
                  )}
                  {orderData.type === 'delivery' && (
                    <>Delivery - {orderData?.referenceNumber}</>
                  )}
                </>
              )}
            </div>

            {!payment && (
              <div className="flex gap-3 items-center  ">
                {!openTicket && (
                  <div
                    onClick={() => {
                      navigate('/open-tickets');
                    }}
                  >
                    <TicketIcon size={25} />
                  </div>
                )}

                {isEditing && (
                  <>
                    <div
                      id="basic-button"
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      // @ts-ignore
                      onClick={handleClick}
                    >
                      <PiDotsThreeVerticalBold fontSize={22} />
                    </div>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                      PaperProps={{
                        style: {
                          boxShadow: 'none',
                          width: '150px',
                          marginTop: '10px',
                          border: '1px solid #F1F0F6',
                          height: 'fit-content',
                          backgroundColor: '#FFFFFF',
                          padding: '12px 24px',
                          overflow: 'hidden',
                        },
                      }}
                    >
                      <div
                        className={`font-Outfit text-center font-normal text-[16px] leading-6  text-warning cursor-pointer `}
                        onClick={() => {
                          // cancelOrder();
                          setShowModal(true);
                          setAnchorEl(null);
                        }}
                      >
                        Cancel Order
                      </div>
                    </Menu>{' '}
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>

      {assignCustomerModal ? (
        <>
          <div className="flex w-[332px] flex-col gap-2 px-[15px]">
            <div
              className="w-full h-[45px] my-3 border border-primary rounded-xl flex justify-center items-center gap-2 cursor-pointer"
              onClick={() => {
                setShowCreateCustomerModal(true);
              }}
            >
              <div className="font-Sarabun font-semibold text-[16px] text-primary">
                Create customer
              </div>
            </div>
          </div>
          {showCreateCustomerModal && (
            <Modal
              title="Create Customer"
              onClick={handleModal}
              className="w-[388px]"
            >
              <div className="mt-4">
                <Formik
                  initialValues={intValues}
                  validateOnMount
                  validationSchema={FORM_VALIDATION}
                  onSubmit={handleCreateCustomer}
                >
                  {({ isSubmitting, isValid }) => (
                    <Form className="mt-5">
                      <TextField
                        label="Name"
                        name="name"
                        labelClassName="text-sm  text-[#2B2B2B] font-Outfit"
                      />
                      <TextField
                        label="Email"
                        name="email"
                        labelClassName="text-sm  text-[#2B2B2B] font-Outfit"
                      />
                      <TextField
                        label="Phone"
                        name="phone"
                        type="text"
                        labelClassName="text-sm  text-[#2B2B2B] font-Outfit"
                      />

                      <div className="flex flex-row justify-end gap-6 items-center w-full">
                        <div
                          className="font-Sarabun font-semibold text-base text-primary cursor-pointer"
                          onClick={handleModal}
                        >
                          Cancel
                        </div>
                        <Button
                          text="Create"
                          variant="primary"
                          type="submit"
                          className=""
                          disabled={createCustomerLoading}
                          isSubmitting={isSubmitting}
                          isValid={isValid}
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Modal>
          )}
          <div className="flex w-[332px] px-[15px] mb-[15px]">
            <div className="w-full relative flex items-center  h-[41px]">
              <input
                type="text"
                placeholder="Search customers"
                className="pr-9 flex-1 w-full px-4 py-2 border border-[#CACFE3] rounded-full focus:outline-none   "
                onChange={(e) => {
                  setFilteredSearchCustomers(e.target.value);
                }}
              />
              <div className="absolute right-3">
                <HiSearch color="#7F8397" style={{ fontSize: '20px' }} />
              </div>
            </div>
          </div>
          <div className="flex flex-col w-[332px] flex-grow overflow-y-scroll px-[15px] gap-3 ">
            {filteredCustomers.length > 0 ? (
              <>
                {' '}
                {filteredCustomers.map((customer) => (
                  <div
                    key={'order_filteredCustomers_' + customer.id}
                    onClick={() => {
                      if (selectedCustomer) {
                        setSelectedCustomer('');
                      } else {
                        setSelectedCustomer(customer.id);
                      }
                    }}
                    className={`w-full h-[75px] flex flex-row p-4 cursor-pointer items-center rounded-xl border ${
                      selectedCustomer === customer.id
                        ? 'border-primary'
                        : 'border-[#F1F0F6]'
                    }`}
                  >
                    <Avatar src={customer?.image || ''} className="mr-3" />
                    <div className="">
                      <div className="font-Outfit font-semibold text-base text-[#2B2B2B]">
                        {customer.name}
                      </div>
                      <div className="font-Outfit font-normal text-sm text-[#949CC0]">
                        {customer.phone}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="text-center m-5">No customers found</div>
            )}
          </div>
          <div className="flex w-[332px] flex-col gap-2 px-[15px] mt-auto">
            <div
              className="w-full h-[45px] my-3  bg-primary rounded-xl flex justify-center items-center gap-2 cursor-pointer"
              onClick={() => {
                // if (openTicket && orderData.paymentStatus !== 'paid') {
                // const user = true;
                // addCurrentCustomer(user);
                // } else {
                addCurrentCustomer(true);
                // }
              }}
            >
              <div className="font-Sarabun font-semibold text-[16px] text-[#FFF]">
                Select customer
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {!payment && (
            <div className="flex w-[332px] flex-col gap-2 px-[15px] ">
              {orders.origin === 'online' ? (
                <div
                  className={`w-full h-[75px] flex flex-row px-4 items-center rounded-xl border border-[#F1F0F6] my-3 `}
                >
                  <Avatar
                    src={orders?.customer?.image || ''}
                    className="mr-3"
                  />
                  <div>
                    <div className="font-Outfit font-semibold text-base text-[#2B2B2B]">
                      {orders?.customer?.name}
                    </div>
                    <div className="font-Outfit font-normal text-sm text-[#949CC0]">
                      {orders?.customer?.name}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {' '}
                  {currentUser ? (
                    <>
                      <div
                        className={`w-full h-[75px] flex flex-row px-4 items-center rounded-xl border border-[#F1F0F6] my-3 `}
                      >
                        <Avatar
                          src={currentUser?.image || ''}
                          className="mr-3"
                        />
                        <div>
                          <div className="font-Outfit font-semibold text-base text-[#2B2B2B]">
                            {currentUser.name}
                          </div>
                          <div className="font-Outfit font-normal text-sm text-[#949CC0]">
                            {currentUser.phone}
                          </div>
                        </div>
                        <AiOutlineDelete
                          onClick={() => {
                            changeUserEmpty();
                            dispatch(addCurrentUser(null));
                          }}
                          style={{ marginLeft: 'auto' }}
                          fontSize={20}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className="w-full h-[50px] my-3 border border-primary rounded-xl flex justify-center items-center gap-2 cursor-pointer"
                        onClick={() => {
                          setAssignCustomerModal(true);
                        }}
                      >
                        <GoPlusCircle fontSize={22} color="#4062FF" />
                        <div className="font-Sarabun font-semibold text-[16px] text-primary">
                          Assign to customer
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          )}

          {orders.items.length > 0 && (
            <div className="flex flex-col  gap-2 px-[15px] mb-3  flex-grow overflow-hidden">
              <div
                className={`w-full  flex-grow overflow-auto ${
                  payment && 'mt-3'
                }`}
              >
                {orders?.items.map((item, i) => {
                  let priceWithModifiers = 0;

                  if (item.quantity > 0) {
                    if (item.selectedModifiers.length > 0) {
                      item.selectedModifiers.forEach((a) => {
                        a.options.forEach((b) => {
                          if (b.hasSelected) {
                            priceWithModifiers += b.price;
                          }
                        });
                      });
                    }
                  }
                  return (
                    <div
                      key={'orders_items_' + i + item.id}
                      className="flex items-center justify-between"
                    >
                      <div
                        className={`pb-1 pr-1 mt-1 w-full   ${
                          i !== orders.items.length - 1
                            ? 'border-b border-[#F1F0F6]'
                            : ''
                        } `}
                      >
                        <div
                          className={`w-full min-h-[24px] h-fit flex justify-between items-center  `}
                        >
                          {!payment && !openTicket && (
                            <div className="font-Outfit w-[100px]  font-semibold text-[16px] leading-6 flex gap-[5px]  ">
                              <div className="w-full break-words overflow-hidden   ">
                                {' '}
                                {item.name !== item?.variantName
                                  ? `${item?.name} (${item?.variantName})`
                                  : `${item?.variantName}`}
                              </div>
                            </div>
                          )}
                          {payment && !openTicket && (
                            <div className="font-Outfit w-fit h-fit items-center  font-semibold text-[16px] leading-6 flex gap-[6px]  ">
                              <div className="max-w-[150px] break-words ">
                                {item.name !== item?.variantName
                                  ? `${item?.name}(${item?.variantName})`
                                  : `${item?.variantName}`}{' '}
                              </div>
                              <img src={Tag} alt="Tag" />
                              <span>x{item?.quantity}</span>
                            </div>
                          )}
                          {openTicket && !payment && (
                            <div className="font-Outfit w-fit h-fit items-center  font-semibold text-[16px] leading-6 flex gap-[6px]  ">
                              <div className="max-w-[150px] break-words ">
                                {item.name !== item?.variantName
                                  ? `${item?.name}(${item?.variantName})`
                                  : `${item?.variantName}`}{' '}
                              </div>
                              <img src={Tag} alt="Tag" />
                              <span>x{item?.quantity}</span>
                            </div>
                          )}
                          {!payment && !openTicket && (
                            <div className="flex items-center gap-[5px]">
                              <div
                                className={`w-[20px] h-[20px] rounded-[4px] ${
                                  item?.quantity === 0 ||
                                  (item.decreaseLimit !== null &&
                                    item.quantity === item?.decreaseLimit)
                                    ? 'bg-[#CACFE3]'
                                    : 'bg-[#949CC0]'
                                }  flex justify-center items-center`}
                                onClick={async () => {
                                  {
                                    const id = item.identifierId
                                      ? item.identifierId
                                      : item.variantId;
                                    await dispatch(
                                      decreaseQuantityOrder({
                                        id: id,
                                        quantity: item.quantity - 1,
                                        decreaseLimit: item?.decreaseLimit,
                                      })
                                    );
                                    const newOrders = {
                                      ...orders,
                                      items: orders.items.map((item: any) => {
                                        const idToCheck =
                                          item.identifierId || item.variantId;

                                        if (idToCheck === id) {
                                          return {
                                            ...item,
                                            quantity: item.quantity - 1,
                                          };
                                        }
                                        return item;
                                      }),
                                    };
                                    const pay = false;
                                    await saveTicketWithExistingItems(
                                      pay,
                                      newOrders,
                                      orders?.items ?? []
                                    );
                                    fetchTableDataBackOffice();
                                  }
                                }}
                              >
                                <BiMinus color="FFF" />
                              </div>
                              <div className="w-[20px] h-[20px]  flex justify-center items-center font-Sarabun font-normal text-xs">
                                {item.quantity}
                              </div>
                              <div
                                className="w-[20px] h-[20px] rounded-[4px] bg-[#949CC0] flex justify-center items-center"
                                onClick={async () => {
                                  {
                                    const id = item.identifierId
                                      ? item.identifierId
                                      : item.variantId;
                                    await dispatch(
                                      increaseQuantityOrder({
                                        id: id,
                                        quantity: item.quantity + 1,
                                      })
                                    );
                                    const newOrders = {
                                      ...orders,
                                      items: orders.items.map((item: any) => {
                                        const idToCheck =
                                          item.identifierId || item.variantId;

                                        if (idToCheck === id) {
                                          return {
                                            ...item,
                                            quantity: item.quantity + 1,
                                          };
                                        }
                                        return item;
                                      }),
                                    };
                                    const pay = false;
                                    await saveTicketWithExistingItems(
                                      pay,
                                      newOrders,
                                      orders?.items ?? []
                                    );
                                    fetchTableDataBackOffice();
                                  }
                                }}
                              >
                                <BsPlusLg color="FFF" />
                              </div>
                            </div>
                          )}
                          {item?.price ? (
                            <div className="font-Outfit font-normal text-[16px] leading-6  w-[80px] flex justify-end">
                              {renderCalculatedPrice(item)}
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                        {item?.selectedModifiers?.length > 0 ? (
                          <>
                            {item.selectedModifiers.map((mod) => (
                              <div
                                key={'orders_item.selectedModifiers_' + mod.id}
                              >
                                {mod.options
                                  .filter((option) => option.hasSelected)
                                  .map((option: any) => (
                                    <div
                                      key={
                                        'orders_item.selectedModifiers_op_' +
                                        option.id
                                      }
                                      className="w-full h-[21px] flex justify-between items-center"
                                    >
                                      <div className="font-Outfit font-normal text-[14px] leading-[21px] text-[#949CC0]">
                                        {option.name}
                                      </div>
                                      <div className="font-Outfit font-normal text-[14px] leading-[21px] text-[#949CC0]">
                                        <CurrencyAmount amount={option.price} />
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            ))}
                          </>
                        ) : (
                          <></>
                        )}

                        {item?.spiceLevel && item.spiceLevel !== 'No' ? (
                          <>
                            <div className="w-full h-[21px] flex justify-between items-center">
                              <div className="font-Outfit font-normal text-[14px] leading-[21px] text-[#949CC0]">
                                Spice level
                              </div>
                              <div className="font-Outfit font-normal text-[14px] leading-[21px] text-[#949CC0]">
                                {item?.spiceLevel}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {!payment && item?.note ? (
                          <div className="w-full mt-1 h-fit flex flex-row break-words font-Sarabun font-normal italic text-sm text-[#7F8397]">
                            Note: {item?.note}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      {window.location.pathname.includes('payment') || window.location.pathname.includes('open-tickets')
                        ? null
                        : ApplyDiscount(item)}
                      {window.location.pathname.includes('payment') || window.location.pathname.includes('open-tickets')
                        ? null
                        : UpdateDiscount(item)}
                    </div>
                  );
                })}
              </div>
              {window.location.pathname.includes('payment') || window.location.pathname.includes('open-tickets')
                ? null
                : DiscountApplyDiv()}
              <div className="w-full flex flex-col border-b border-t py-2 border-[#CACFE3] mt-auto">
                <div className="w-full h-[24px] flex justify-between items-center">
                  <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#949CC0]">
                    Subtotal
                  </div>
                  <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#2B2B2B]">
                    <CurrencyAmount amount={subTotal} />
                  </div>
                </div>
                {renderDiscountInfoTotal()}
                {renderDiscountInfoTotalWhole()}
                <hr className="text-primary-light" />
                {renderAmountAfterDiscount()}
                {orders?.promo && orders?.promo !== null && (
                  <div className="w-full h-[24px] flex justify-between items-center">
                    <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#949CC0]">
                      {orders?.promo?.name}
                      {orders?.promo?.type === 'percent' &&
                        ` (${orders?.promo?.value}%)`}
                    </div>
                    <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#E22B41]">
                      <CurrencyAmount
                        amount={
                          orders.promo?.type === 'percent'
                            ? (orders.promo.value / 100) * subTotal
                            : orders.promo.value
                        }
                      />
                    </div>
                  </div>
                )}
                {taxes.length > 0 &&
                  taxes.map((tax: any, taxIndex: number) => {
                    return (
                      <div
                        key={'orders_taxes_' + taxIndex}
                        className="w-full h-[24px] flex justify-between items-center"
                      >
                        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#949CC0]">
                          {tax?.name}
                          {tax?.type === 'percent' && ` (${tax?.value}%)`}
                        </div>
                        <div className="font-Outfit font-normal text-[16px] leading-[24px] text-[#2B2B2B]">
                          <CurrencyAmount amount={tax?.amount} />
                        </div>
                      </div>
                    );
                  })}
              </div>
              {renderTotal()}
              {showModal && (
                <Modal
                  title="Reason for Cancellation?"
                  onClick={() => handleCloseModal()}
                  modalSize="30"
                >
                  <div className="mx-5">
                    <div className="mb-6">
                      <textarea
                        className="border-[1px] w-full border-light-gray rounded-xl px-1 py-2 focus:border-[1px] focus:border-primary-200 mt-3 focus:shadow-none focus:ring-0 focus:outline-none text-sm  text-[#2B2B2B] font-Outfit"
                        rows={5}
                        cols={42}
                        value={cancelReason}
                        onChange={(e) => {
                          setCancelReason(e.target.value);
                        }}
                      />
                    </div>
                    <div className="flex flex-row justify-end gap-6 items-center w-full">
                      <div
                        className="font-Sarabun font-semibold text-base text-primary cursor-pointer"
                        onClick={() => handleCloseModal()}
                      >
                        Cancel
                      </div>
                      <button
                        className="bg-primary text-pure-white w-[150px] h-[41px] flex justify-center items-center font-Outfit font-semibold text-sm rounded-lg"
                        type="submit"
                        onClick={() => {
                          cancelOrder();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Modal>
              )}
            </div>
          )}
          {!payment && !openTicket && (
            <div className="w-full h-[41px] gap-2 flex justify-between items-center mb-2 px-3 mt-auto">
              {orders?.items?.length > 0 && (
                <div className="relative group ml-auto">
                  <div
                    className={`w-[141px] h-[41px] ml-auto flex justify-center bg-[#4062FF] text-[#FFFFFF] items-center rounded-lg font-Outfit font-semibold text-[14px] leading-5 ${
                      allowOrderCharge
                        ? 'cursor-pointer'
                        : 'cursor-not-allowed opacity-50'
                    }`}
                    onClick={() => {
                      allowOrderCharge &&
                        navigate('/payment', {
                          state: {
                            tableId: tableId,
                            wholeTable: true,
                            discountSend,
                          },
                        });
                    }}
                  >
                    {chargeWholeLoading ? (
                      <CircularProgress style={{ color: '#FFF' }} size={20} />
                    ) : (
                      'Charge'
                    )}
                  </div>

                  {/* Tooltip */}
                  {!allowOrderCharge && (
                    <div className="absolute bottom-full mb-2 right-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-black text-pure-white text-xs px-2 py-1 rounded whitespace-nowrap z-10">
                      Insufficient permissions to charge order
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {/* from open-ticket */}
          {openTicket &&
            orderData.paymentStatus !== 'paid' &&
            orders?.items?.length > 0 && (
              <div className="relative group m-2 hidden">
                <div
                  className={`h-[41px] min-h-[41px] m-2 flex justify-center bg-[#4062FF] text-[#FFFFFF] items-center rounded-lg font-Outfit font-semibold text-[14px] leading-5 ${
                    allowOrderCharge
                      ? 'cursor-pointer'
                      : 'cursor-not-allowed opacity-50'
                  }`}
                  onClick={() => {
                    allowOrderCharge &&
                      navigate('/payment', {
                        state: { orderId: orderData.id, discountSend },
                      });
                  }}
                >
                  Charge
                </div>

                {/* Tooltip */}
                {!allowOrderCharge && (
                  <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap z-10">
                    Insufficient permissions to charge order
                  </div>
                )}
              </div>
            )}
        </>
      )}

      {FinalBillPrintProv(
        orders,
        orderInfo,
        currentUser,
        businessName,
        businessAddress,
        panNumber
      )}
    </div>
  );
};

export default Order;
